<template>
  <button
    class="dependentdropdown__btn"
    type="button"
    @click="onClick"
  >
    <slot />
    {{ text }}
  </button>
</template>

<script>
  export default {
    name: 'Button',
    props: {
      text: {
        type: String,
        required: true
      }
    },
    methods: {
      onClick() {
        this.$emit('related-dropdown-click');
      }
    }
  };
</script>


<style lang="scss">
.dependentdropdown{
  &__btn {
    background-color: $color-button-primary;
    border: 0;
    border-radius: 5px;
    cursor: pointer;
    display: inline-flex;
    outline: 0;
    max-height: $height-max-button;
    padding: 14.4px 20px;
    transition: $transition-link;
    color: $white;
    text-decoration: none;
    flex: 1;
    font-size: 16px;
    justify-content: center;
    text-align: center;

    &:focus {
      box-shadow: 0 0 0 1px $white, 0 0 0 3px $color-outline;
      outline: 0;
    }

    &:hover {
      background-color: darken($color-button-primary, 5%);
      color: $color-text-inverse;
    }
  }
}
</style>
